module.exports = __webpack_public_path__ + "img/dp_logo.a5e67c3.png";